import { Button, Paper } from "@mui/material";
import { Controller } from "react-hook-form";
import { JobSelectionList } from "../JobSelectionList";
import { MarkJobReadyFormProps, VALIDATION_RULES } from "./MarkJobReadyForm.types";
import { useMarkJobReadyFormViewModel } from "./MarkJobReadyForm.vm";
import "./MarkJobReadyForm.css";

/**
 * MarkJobReadyForm View Component
 * Pure presentational component that renders the form UI
 * All business logic is handled by the ViewModel
 */
export function MarkJobReadyForm(props: MarkJobReadyFormProps) {
	const { onCancel, showCancel } = props;

	// Get all state and handlers from ViewModel
	const vm = useMarkJobReadyFormViewModel(props);

	return (
		<Paper className="mark-job-ready-form">
			<form>
				{/* Job Selection List with validation */}
				<div className="job-selection-wrapper">
					<Controller
						name="selectedJobs"
						control={vm.control}
						rules={VALIDATION_RULES.selectedJobs}
						render={({ field: { value, onChange }, fieldState: { error } }) => (
							<JobSelectionList jobs={vm.jobs} value={value || []} onChange={onChange} error={error?.message} />
						)}
					/>
				</div>

				{/* Cancel Button (optional) */}
				{showCancel && (
					<div className="cancel-button-wrapper">
						<Button onClick={onCancel}>Cancel</Button>
					</div>
				)}

				{/* Submit Button */}
				<Button fullWidth variant="contained" onClick={vm.handleFormSubmit}>
					{`Mark ${vm.jobsSelected} jobs as ready`}
				</Button>
			</form>
		</Paper>
	);
}
